export default __webpack_public_path__ + "static/media/icon.d9aa5a0e.png";